import type { FunctionComponent } from 'react';

import { Button, Icon, Text } from '@kanda-libs/ks-design-library';

interface CreditLinesFooter {
  isLoading: boolean;
  isSubmitting: boolean;
}

const Footer: FunctionComponent<CreditLinesFooter> = function ({
  isLoading,
  isSubmitting,
}) {
  return (
    <div className="flex flex-col mt-12">
      <Button.Text
        submit
        id="aip-form-submit"
        label="Accept Quote & Apply for Loan"
        variant="gradient"
        className="mb-8"
        icon="check"
        left
        disabled={isLoading || isSubmitting}
        isLoading={isLoading}
      />
      <div className="flex flex-row items-center justify-center w-full">
        <Icon
          icon="error"
          size={16}
          stroke="neutral-600"
          className="mr-4 min-w-4"
        />
        <Text
          text="No costs if you are not approved"
          className="text-16-24 text-neutral-600"
        />
      </div>
    </div>
  );
};

Footer.displayName = 'Footer-view';

export default Footer;
